import { hasAnyPermission } from '@inference.engine/permissions/web';
import { applyAdminOverride, useAdminOverrideDisabled } from './admin-override';

/**
 * Applies the org/workspace-admin override to a list the caller already holds,
 * rather than one resolved into the scoped-permissions store. Use it to gate many
 * resources at once: that store tracks a single identifier per scope, so it
 * cannot answer "may I edit each of these twenty projects?".
 */
export function usePermissionCheck(): (
  granted: string[] | undefined,
  required: readonly string[],
) => boolean {
  const adminOverrideDisabled = useAdminOverrideDisabled();
  return (granted, required) =>
    hasAnyPermission(granted ?? [], applyAdminOverride(required, adminOverrideDisabled));
}
